import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { Constants } from './constants';
import { LoginType } from './enums';

export class Extensions {
	public static returnUrl: string = '';

	public static calculateCodeExpiration(codeCreatedOn: Date, durationInSecods: number): number {
		let UTCString: string = new Date(codeCreatedOn).toUTCString();
		let UTCStringNow: string = new Date().toUTCString();

		const diffInSeconds = Extensions.getDiffInSeconds(
			new Date(UTCString),
			new Date(UTCStringNow)
		);
		return durationInSecods - diffInSeconds;
	}

	public static getDiffInSeconds(date: Date, compareTo: Date): number {
		var dif = date.getTime() - compareTo.getTime();

		var Seconds_from_T1_to_T2 = dif / 1000;
		var Seconds_Between_Dates = Math.abs(Seconds_from_T1_to_T2);

		return Math.round(Seconds_Between_Dates);
	}

	public static getReturnUrl(queryParams: Params) {
		return queryParams['returnUrl'] || queryParams['ReturnUrl'];
	}

	public static setReturnUrl(queryParams: Params) {
		const returnUrl = queryParams['returnUrl'] || queryParams['ReturnUrl'];
		Extensions.returnUrl = returnUrl;
	}

	public static getLoginTypeLowerCase(queryParams: Params): string | null {
		let loginTypeParam = queryParams['loginType'];
		if (loginTypeParam != null) {
			return loginTypeParam.toLowerCase();
		} else {
			const returnUrl = queryParams['returnUrl'] || queryParams['ReturnUrl'];
			if (!returnUrl) return null;
			const urlParams = new URLSearchParams(returnUrl);
			if (!urlParams) return null;
			loginTypeParam = urlParams.get('loginType');
			if (!loginTypeParam) return null;
			return loginTypeParam.toLowerCase();
		}
	}

	public static setSelectedLoginType(
		router: Router,
		route: ActivatedRoute,
		type: LoginType
	): void {
		LoginService.setType(type);
		router.navigate([], {
			relativeTo: route,
			queryParams: {
				loginType:
					type == LoginType.Corporate ? Constants.Corporate_Type : Constants.Retail_Type,
			},
			queryParamsHandling: 'merge',
		});
	}

	public static isLinkUserErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 4012 && errorCode <= 4020;
	}

	public static isOtpErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 7000 && errorCode <= 7999;
	}

	public static isTwofaErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 6000 && errorCode <= 6999;
	}
	public static isOnboardMissingValuesErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 4002 && errorCode <= 4033;
	}
	public static isOnBoardPersonalDetailsErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 1012 && errorCode <= 1027;
	}
	public static isOnBoardEmailErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 7004 && errorCode <= 7010;
	}

	public static isOnBoardUnexpectedErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 8007 && errorCode <= 8008;
	}
	public static isOnBoardInternetBankingErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 9001 && errorCode <= 9004;
	}
	public static isOnBoardValidityErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 5003 && errorCode <= 5200;
	}
	public static isOnBoardVerificationErrorCode(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode >= 60006 && errorCode <= 60014;
	}

	public static isOnBoardNewErrorCodes(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return (
			errorCode ==
			(1012 ||
				1015 ||
				1016 ||
				1017 ||
				1018 ||
				1020 ||
				1021 ||
				1025 ||
				5013 ||
				4009 ||
				4019 ||
				5004 ||
				60011 ||
				60012 ||
				60013 ||
				60014 ||
				7004)
		);
	}

	public static isIdentityNewErrorCodes(errorCode: number): boolean {
		if (isNaN(errorCode)) return false;
		return errorCode == (1001 || 7002 || 7003 || 6002 || 6001 || 7004);
	}
}
